import { Col, Row } from "react-bootstrap";
import { CrudPlaceholderInput } from "../../../../general/modules/commons/crud/inputs/crudPlaceholderInput";

export const DefaultRouteMutateFormTemplate = () => {
  return (
    <Row>
      <Col xs={12}>
        <CrudPlaceholderInput name="name" />
      </Col>
    </Row>
  );
};
